import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import SelectBox from "components/Forms/Elements/Selectbox";
import Translate from "helpers/Translate";

const Departments = ({  handleChangeDepartment }) => {
  const getDepartment = useSelector(state => state.department.getDepartment);
  const [departments, setDepartments] = useState([]);
  const [choosenDepartment, setChoosenDepartment] = useState("");

  useEffect(() => {
    if (getDepartment?.items) {
      setChoosenDepartment("");
      let options = [
        {
          label: Translate({ id: "select_collection" }),
          value: ""
        }
      ];
      options = options.concat(
        getDepartment.items.map(item => ({
          label: item.title,
          value: item.value
        }))
      );
      setDepartments(options);
    } else {
      setDepartments([]);
    }
  }, [getDepartment]);

  return (
    <>
      <SelectBox
        id="departments"
        name="departments"
        disabled={!departments.length}
        onChange={e => {
          setChoosenDepartment(e.target.value);
          handleChangeDepartment(e.target.value);
        }}
        errorKey="departments"
        fieldValue={choosenDepartment}
        options={departments}
        onReturnKey={() => {}}
      />
    </>
  );
};

Departments.propTypes = {
  handleChangeDepartment: PropTypes.func.isRequired
};

export default Departments;
